import MuiSlider from "@mui/material/Slider";

const Slider = MuiSlider;

export default Slider;
